
import { HomeContent } from "@/components/home/HomeContent";
import { ExitIntentPopup } from "@/components/ExitIntentPopup";

interface IndividualPageContentProps {
  showWaitlist: boolean;
  setShowWaitlist: (show: boolean) => void;
  onUserTypeChange: (isPro: boolean) => void;
}

export const IndividualPageContent = ({
  showWaitlist,
  setShowWaitlist,
  onUserTypeChange
}: IndividualPageContentProps) => {
  return (
    <div className="flex-grow">
      <HomeContent 
        defaultIsPro={false}
        showWaitlist={showWaitlist}
        setShowWaitlist={setShowWaitlist}
        onUserTypeChange={onUserTypeChange}
      />
      <ExitIntentPopup />
    </div>
  );
};
